(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';var _VeDailyPriceChart = require('./vueComponents/VeDailyPriceChart');var _VeDailyPriceChart2 = _interopRequireDefault(_VeDailyPriceChart);
var _cloakHiddenDirective = require('./vueDirectives/cloakHiddenDirective');var _cloakHiddenDirective2 = _interopRequireDefault(_cloakHiddenDirective);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

document.addEventListener('DOMContentLoaded', function () {
    (0, _cloakHiddenDirective2.default)();
    (0, _VeDailyPriceChart2.default)();
});

},{"./vueComponents/VeDailyPriceChart":2,"./vueDirectives/cloakHiddenDirective":3}],2:[function(require,module,exports){
"use strict";var _vue = require("vue");var _vue2 = _interopRequireDefault(_vue);
var _dayjs = require("dayjs");var _dayjs2 = _interopRequireDefault(_dayjs);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
require("dayjs/locale/en");
require("dayjs/locale/da");
require("dayjs/locale/pl");

var Chart = window.Chart;

var debounce = function debounce(func) {var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var timeout = void 0;
  return function () {var _this = this;for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      func.apply(_this, args);
    },
    wait);
  };
};
var axisLabelConfig = function axisLabelConfig() {
  return {
    display: true,
    text: "",
    padding: 10,
    font: {
      size: 16,
      weight: 500 },

    align: "end" };

};

var baseChartConfig = function baseChartConfig() {
  return {
    type: "bar",
    options: {
      normalized: true,
      layout: {
        padding: 0 },

      animation: {
        duration: 300 },

      scales: {
        y: {
          title: axisLabelConfig() },

        x: {
          title: axisLabelConfig(),
          barPercentage: 0.4 } },


      plugins: {
        tooltip: {
          callbacks: {
            title: function title(context) {
              return context[0].label + " - " + context[0].label.split(":")[0] + ":59";
            } },

          displayColors: false },

        legend: {
          display: false } } } };




};

var VeDailyPriceChartApp = function VeDailyPriceChartApp() {
  var appDivs = document.querySelectorAll(".js-daily-price-chart");
  if (appDivs) {
    var currentCulture = document.documentElement.getAttribute("data-current-culture");
    _dayjs2.default.locale(currentCulture);var _loop = function _loop(
    index) {
      var element = appDivs[index];
      var chartTitle = element.getAttribute("data-chart-title");
      var yAxisLabel = element.getAttribute("data-chart-y-label");
      var xAxisLabel = element.getAttribute("data-chart-x-label");
      new _vue2.default({
        el: element,
        data: function data() {
          return {
            date: null,
            chartData: [],
            east: false,
            chartInstance: null,
            isLoading: true,
            isError: false,
            isMobile: false,
            mobileThreshold: 640 };

        },
        mounted: function mounted() {var _this2 = this;
          this.date = new Date();
          this.isMobile = window.innerWidth <= this.mobileThreshold;
          var debounceResize = debounce(
          function () {
            _this2.isMobile = window.innerWidth <= _this2.mobileThreshold;
          },
          50);
          window.addEventListener("resize", debounceResize);
          this.fetchPrices();
          this.createChart();
        },
        watch: {
          currentDataset: function currentDataset(newValue) {
            if (newValue && newValue.HourlyRate) {
              this.updateChart();
            }
          },
          east: function east() {var _this3 = this;
            this.$nextTick(function () {
              _this3.fetchPrices();
            });
          },
          isMobile: function isMobile(newValue, oldValue) {var _this4 = this;
            if (newValue != oldValue) {
              this.$nextTick(function () {
                // Need to recreate chart when changing indexAxis. Otherwise it breaks.
                _this4.createChart();
              });
            }
          } },

        computed: {
          region: function region() {
            return this.east ? "east" : "west";
          },
          currentDataset: function currentDataset() {
            var values = Object.values(this.chartData);
            var activeDateTimestamp = (0, _dayjs2.default)(this.date).format("YYYYMMDD");
            return values.find(function (el) {
              return (0, _dayjs2.default)(el.Date).format("YYYYMMDD") == activeDateTimestamp;
            });
          },
          displayDate: function displayDate() {
            return (0, _dayjs2.default)(this.date).format("dddd D. MMMM YYYY");
          },
          chartDataSorted: function chartDataSorted() {
            var chartData = Object.values(this.chartData);
            return chartData.sort(function (a, b) {
              return (0, _dayjs2.default)(a.Date).isBefore((0, _dayjs2.default)(b.Date)) ? 1 : -1;
            });
          },
          maxDate: function maxDate() {
            var maxDate = this.chartDataSorted.length > 0 ? this.chartDataSorted[0].Date : "";
            return (0, _dayjs2.default)(maxDate).format("YYYYMMDD");
          },
          minDate: function minDate() {
            var minDate = this.chartDataSorted.length > 0 ?
            this.chartDataSorted[this.chartDataSorted.length - 1].Date :
            "";
            return (0, _dayjs2.default)(minDate).format("YYYYMMDD");
          },
          currentDate: function currentDate() {
            return (0, _dayjs2.default)(this.date).format("YYYYMMDD");
          },
          canGoForward: function canGoForward() {
            return this.currentDate < this.maxDate;
          },
          canGoBack: function canGoBack() {
            return this.currentDate > this.minDate;
          } },

        methods: {
          ensureValidDate: function ensureValidDate() {var _this5 = this;
            var dataHasCurrentDay = this.chartData.find(function (el) {
              return (0, _dayjs2.default)(_this5.date).format("YYYYMMDD") == (0, _dayjs2.default)(el.Date).format("YYYYMMDD");
            });
            if (!dataHasCurrentDay) {
              this.date = (0, _dayjs2.default)(this.maxDate).toDate();
            }
          },
          fetchPrices: function fetchPrices() {var _this6 = this;
            this.isLoading = true;
            var route = "/umbraco/api/graphs/get?region=" + this.region;
            fetch(route).
            then(function (res) {return res.json();}).
            then(function (data) {
              _this6.chartData = data;
              _this6.ensureValidDate();
            }).
            catch(function () {
              _this6.isError = true;
            }).
            finally(function () {
              _this6.isLoading = false;
            });
          },
          updateChart: function updateChart() {
            var canvas = this.$refs["chart"];
            if (!canvas || !this.currentDataset || !this.chartInstance) {
              return;
            }
            var themeColor = getComputedStyle(canvas).color || "#84bd00";
            var labels = Object.keys(this.currentDataset.HourlyRate);
            var axisDisplay = this.isMobile ? false : true;
            var barWidth = this.isMobile ? .8 : 1;
            var values = Object.values(this.currentDataset.HourlyRate).map(function (price) {
              return parseFloat(price).toFixed(1);
            });

            var data = {
              labels: labels,
              datasets: [
              {
                backgroundColor: themeColor,
                barPercentage: barWidth,
                label: chartTitle,
                data: values }] };




            this.chartInstance.options.scales.y.title.display = axisDisplay;
            this.chartInstance.options.aspectRatio = this.isMobile ? 0.75 : 2;
            this.chartInstance.data = data;
            this.chartInstance.update();
            this.chartInstance.resize();
          },
          createChart: function createChart() {
            var canvas = this.$refs["chart"];
            if (!canvas) {
              return;
            }
            if (this.chartInstance) {
              this.chartInstance.destroy();
            }
            var chartConfig = baseChartConfig();
            chartConfig.options.scales.x.title.text = xAxisLabel;
            chartConfig.options.scales.y.title.text = yAxisLabel;
            this.chartInstance = new Chart(canvas, chartConfig);
            this.updateChart();
          },
          prevDate: function prevDate() {
            var date = (0, _dayjs2.default)(this.date);
            if (this.currentDate <= this.minDate) {
              return;
            }
            this.date = date.subtract(1, "day").toDate();
          },
          nextDate: function nextDate() {
            var date = (0, _dayjs2.default)(this.date);
            if (this.currentDate >= this.maxDate) {
              return;
            }
            this.date = date.add(1, "day").toDate();
          } } });};for (var index = 0; index < appDivs.length; index++) {_loop(index);


    }
  }
};

module.exports = VeDailyPriceChartApp;

},{"dayjs":4,"dayjs/locale/da":5,"dayjs/locale/en":6,"dayjs/locale/pl":7,"vue":"vue"}],3:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });exports.default =

cloakHiddenDirective;var _vue = require('vue');var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function cloakHiddenDirective() {
  _vue2.default.directive('cloak-hidden', {
    inserted: function inserted(el) {
      // remove tag
      el.removeAttribute('v-cloak-hidden');
      el.classList.remove('v-cloak-hidden');
    } });

}

},{"vue":"vue"}],4:[function(require,module,exports){
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).dayjs=e()}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},v="en",D={};D[v]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return v;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(v=i),i||!r&&v},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var v=this.$locale().weekStart||0,D=(y<v?y+7:y)-v;return $(r?m-D:m+(6-D),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,v=O.m(this,M);return v=(l={},l[c]=v/12,l[f]=v,l[h]=v/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?v:O.a(v)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[v],w.Ls=D,w.p={},w}));
},{}],5:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t(require("dayjs")):"function"==typeof define&&define.amd?define(["dayjs"],t):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_locale_da=t(e.dayjs)}(this,(function(e){"use strict";function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=t(e),n={name:"da",weekdays:"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),weekdaysShort:"søn._man._tirs._ons._tors._fre._lør.".split("_"),weekdaysMin:"sø._ma._ti._on._to._fr._lø.".split("_"),months:"januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),monthsShort:"jan._feb._mar._apr._maj_juni_juli_aug._sept._okt._nov._dec.".split("_"),weekStart:1,ordinal:function(e){return e+"."},formats:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd [d.] D. MMMM YYYY [kl.] HH:mm"},relativeTime:{future:"om %s",past:"%s siden",s:"få sekunder",m:"et minut",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dage",M:"en måned",MM:"%d måneder",y:"et år",yy:"%d år"}};return d.default.locale(n,null,!0),n}));
},{"dayjs":4}],6:[function(require,module,exports){
!function(e,n){"object"==typeof exports&&"undefined"!=typeof module?module.exports=n():"function"==typeof define&&define.amd?define(n):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_locale_en=n()}(this,(function(){"use strict";return{name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")}}));
},{}],7:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t(require("dayjs")):"function"==typeof define&&define.amd?define(["dayjs"],t):(e="undefined"!=typeof globalThis?globalThis:e||self).dayjs_locale_pl=t(e.dayjs)}(this,(function(e){"use strict";function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=t(e);function a(e){return e%10<5&&e%10>1&&~~(e/10)%10!=1}function n(e,t,i){var n=e+" ";switch(i){case"m":return t?"minuta":"minutę";case"mm":return n+(a(e)?"minuty":"minut");case"h":return t?"godzina":"godzinę";case"hh":return n+(a(e)?"godziny":"godzin");case"MM":return n+(a(e)?"miesiące":"miesięcy");case"yy":return n+(a(e)?"lata":"lat")}}var r="stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia".split("_"),_="styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"),s=/D MMMM/,d=function(e,t){return s.test(t)?r[e.month()]:_[e.month()]};d.s=_,d.f=r;var o={name:"pl",weekdays:"niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"),weekdaysShort:"ndz_pon_wt_śr_czw_pt_sob".split("_"),weekdaysMin:"Nd_Pn_Wt_Śr_Cz_Pt_So".split("_"),months:d,monthsShort:"sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"),ordinal:function(e){return e+"."},weekStart:1,yearStart:4,relativeTime:{future:"za %s",past:"%s temu",s:"kilka sekund",m:n,mm:n,h:n,hh:n,d:"1 dzień",dd:"%d dni",M:"miesiąc",MM:n,y:"rok",yy:n},formats:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"}};return i.default.locale(o,null,!0),o}));
},{"dayjs":4}]},{},[1]);
